import React from 'react';
import { useTranslation } from 'react-i18next';

const CookiesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="px-6 py-8 sm:px-10 sm:py-12">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                {t('cookies.title')}
              </h1>
              <p className="text-gray-600">
                {t('cookies.lastUpdated')}: {t('cookies.lastUpdatedDate')}
              </p>
            </div>

            <div className="prose max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.whatAreCookies.title')}
                </h2>
                <p className="text-gray-700 mb-4">
                  {t('cookies.whatAreCookies.description')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.typesOfCookies.title')}
                </h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      {t('cookies.typesOfCookies.essential.title')}
                    </h3>
                    <p className="text-gray-700">
                      {t('cookies.typesOfCookies.essential.description')}
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      {t('cookies.typesOfCookies.analytics.title')}
                    </h3>
                    <p className="text-gray-700">
                      {t('cookies.typesOfCookies.analytics.description')}
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      {t('cookies.typesOfCookies.functional.title')}
                    </h3>
                    <p className="text-gray-700">
                      {t('cookies.typesOfCookies.functional.description')}
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      {t('cookies.typesOfCookies.marketing.title')}
                    </h3>
                    <p className="text-gray-700">
                      {t('cookies.typesOfCookies.marketing.description')}
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.howWeUseCookies.title')}
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>{t('cookies.howWeUseCookies.point1')}</li>
                  <li>{t('cookies.howWeUseCookies.point2')}</li>
                  <li>{t('cookies.howWeUseCookies.point3')}</li>
                  <li>{t('cookies.howWeUseCookies.point4')}</li>
                  <li>{t('cookies.howWeUseCookies.point5')}</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.managingCookies.title')}
                </h2>
                <p className="text-gray-700 mb-4">
                  {t('cookies.managingCookies.description')}
                </p>
                
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <h3 className="text-lg font-medium text-blue-900 mb-2">
                    {t('cookies.managingCookies.browserSettings.title')}
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-blue-800">
                    <li>{t('cookies.managingCookies.browserSettings.chrome')}</li>
                    <li>{t('cookies.managingCookies.browserSettings.firefox')}</li>
                    <li>{t('cookies.managingCookies.browserSettings.safari')}</li>
                    <li>{t('cookies.managingCookies.browserSettings.edge')}</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.thirdParty.title')}
                </h2>
                <p className="text-gray-700 mb-4">
                  {t('cookies.thirdParty.description')}
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li><strong>Google Analytics:</strong> {t('cookies.thirdParty.googleAnalytics')}</li>
                  <li><strong>Stripe:</strong> {t('cookies.thirdParty.stripe')}</li>
                  <li><strong>Intercom:</strong> {t('cookies.thirdParty.intercom')}</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.consent.title')}
                </h2>
                <p className="text-gray-700 mb-4">
                  {t('cookies.consent.description')}
                </p>
                <p className="text-gray-700">
                  {t('cookies.consent.withdrawal')}
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  {t('cookies.contact.title')}
                </h2>
                <p className="text-gray-700 mb-4">
                  {t('cookies.contact.description')}
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-700">
                    <strong>{t('cookies.contact.email')}:</strong> privacy@tvia.ai
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;